var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 32h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M40.316 54.335c-6.257 0-11.299-1.964-11.299-4.543v3.91c0 2.513 5.076 4.543 11.299 4.543h1.564c-.649-1.131-.849-2.413-.849-3.91h-.715zm-.033-10.766c-5.99 0-11.066-1.98-11.066-4.427v3.828c0 2.462 4.942 4.443 11.016 4.443 1.597 0 2.729-.05 4.043-.3 1.581-1.215 3.295-2.196 6.29-2.296.516-.433.682-.866.716-1.531v-4.044c-.15 2.397-5.009 4.327-11 4.327z"
      }
    }), _c('path', {
      attrs: {
        "d": "M29.034 44.118v3.91c0 2.513 5.059 4.543 11.299 4.543h.832c.1-1.381.848-2.829 1.813-4.01-.965.1-1.664.166-2.629.166-6.24.017-11.315-2.013-11.315-4.61zm5.69-2.829c3.412.799 7.605.799 11.017 0 3.41-.799 5.507-2.246 5.507-3.844 0-2.446-4.925-4.426-11.015-4.426-6.09 0-11.016 1.98-11.016 4.426 0 1.598 2.097 3.045 5.508 3.844zM55.94 49.043a7.593 7.593 0 00-10.732 0c-2.962 2.962-2.962 7.771 0 10.75a7.593 7.593 0 0010.733 0c2.978-2.979 2.978-7.788 0-10.75zm-1.197 6.09a1.442 1.442 0 00-1.498.733 1.452 1.452 0 00.167 1.68c-.4.366-.866.65-1.365.832a1.45 1.45 0 00-1.38-.931 1.47 1.47 0 00-1.382.998 3.988 3.988 0 01-1.398-.782c.383-.466.45-1.132.117-1.664a1.43 1.43 0 00-1.548-.682 6.591 6.591 0 01-.1-.85c0-.265.017-.515.067-.764.582.1 1.198-.184 1.497-.733a1.452 1.452 0 00-.166-1.68c.4-.366.865-.65 1.365-.832.216.549.748.948 1.38.932.633 0 1.182-.416 1.365-.999.516.167.999.433 1.398.782a1.424 1.424 0 00-.117 1.664c.317.55.949.816 1.548.682.066.283.1.566.1.85.016.265-.017.515-.05.765z"
      }
    }), _c('path', {
      attrs: {
        "d": "M50.583 52.954c-.799 0-1.464.649-1.464 1.464 0 .799.648 1.464 1.464 1.464.799 0 1.464-.649 1.464-1.464-.016-.815-.665-1.464-1.464-1.464z"
      }
    })])])]));
  }
};